<gstar-clients-grid
  [source]="clients()"
  [query]="query"
  (queryChange)="queryUpdate($event)"
  (create)="create($event)"
  (update)="update($event)"
  (assignUser)="assignUser($event)"
  (assignCountry)="assignCountry($event)"
  (deleteRequested)="onDeleteClientRequested($event)" />
